import {combineReducers} from 'redux';
// @ts-expect-error
import {createReducer} from 'redux-act';

import * as actions from './entity-list-actions';

const isFilterDrawerOpen = createReducer(
    {
        // @ts-expect-error
        [actions.toggleShowFilterDrawer]: (state) => !state,
        // @ts-expect-error
        [actions.setFilterDrawerOpen]: (state, payload) => payload,
    },
    false
);

const defaultPersistedParamsState = {
    leads: null,
    contacts: null,
    accounts: null,
} as const;
// @ts-expect-error
const persistedParams = (state = defaultPersistedParamsState, action) => {
    switch (action.type) {
        case 'ENTITY_LIST_PERSIST_PARAMS':
            return {
                ...state,
                [action.payload.entityType]: action.payload.urlQuery,
            };
        case 'ENTITY_LIST_LOAD_PERSISTED_PARAMS':
            return action.payload;
        default:
            return state;
    }
};

export const entityListReducer = combineReducers({
    isFilterDrawerOpen,
    persistedParams,
});

export type EntityListState = {
    isFilterDrawerOpen: boolean;
    persistedParams: {
        leads: string | null | undefined;
        contacts: string | null | undefined;
        accounts: string | null | undefined;
    };
};
